import styled from 'styled-components';
import PerfectScrollbar from 'react-perfect-scrollbar';

export default styled(PerfectScrollbar)`
  flex: 0 1 auto;
  padding: 3px;
  margin-top: 20px;
  width: 100%;
`;
